// ** Redux Imports
import { combineReducers } from "redux"

// ** Reducers Imports
import activity from "@data/redux/reducers/activity"
import index from "@data/redux/reducers/liveKitRoom"
import navigation from "@data/redux/reducers/navigation"
import alert from "./alert"
import api from "./api"
import camera from "./camera"
import data from "./data"
import intercom from "./intercom"
import liveMode from "./liveMode"
import notifications from "./notifications"
import offlineMode from "./offlineMode"
import precallMemory from "./precallMemory"

const rootReducer = combineReducers({
    alert,
    data, // persisted
    api,
    offlineMode,
    liveMode,
    precallMemory, // persisted
    camera,
    notifications,
    activity,
    navigation,
    liveKitRoom: index,
    intercom,
})

export default rootReducer
